
import React from 'react';
import Shramdhan2023 from 'views/Shramdhan2023'

const SecondarySchoolpage = () => {
  return <Shramdhan2023/>;
};

export default SecondarySchoolpage;